import { useLanguage } from "@/i18n/LanguageContext";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Plug, Play, Gauge, Sparkles } from "lucide-react";

const steps = [
  { i: Plug, title: "Connect", body: "Connect machines, PLCs, sensors, meters, industrial tablets, printers and operators using BEEDIGIT preconfigured hardware and integration options." },
  { i: Play, title: "Execute", body: "Send job orders, instructions, material requirements, quality checks and priorities to operators through BEEPAD industrial tablets." },
  { i: Gauge, title: "Measure", body: "Track output, speed, downtime, OEE, material consumption, scrap, quality results, maintenance events and energy consumption in real time." },
  { i: Sparkles, title: "Improve", body: "Analyze losses, improve schedules, reduce downtime, optimize energy, increase output and feed reliable production data back to ERP, APS and BI." },
];

export default function SolutionOverview() {
  const { t } = useLanguage();
  return (
    <section className="py-16 md:py-20 border-t border-border">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mb-10">
          <p className="eyebrow mb-3">{t("Solution")}</p>
          <h2 className="text-3xl md:text-4xl font-bold mb-3">{t("BEEDIGIT makes your factory visible, controllable and optimizable.")}</h2>
          <p className="text-muted-foreground">
            {t("One industrial platform for real-time monitoring, job execution, QR traceability, quality, maintenance, Andon and energy management.")}
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {steps.map((s, i) => (
            <div key={s.title} className="relative rounded-lg border border-border bg-card p-5">
              <div className="absolute -top-3 -left-3 h-8 w-8 rounded-md bg-primary text-primary-foreground flex items-center justify-center font-bold text-sm font-mono">
                {String(i + 1).padStart(2, "0")}
              </div>
              <s.i className="h-6 w-6 text-primary mb-3" />
              <h3 className="font-semibold mb-2">{t(s.title)}</h3>
              <p className="text-sm text-muted-foreground">{t(s.body)}</p>
            </div>
          ))}
        </div>
        <div className="mt-8">
          <Button variant="outline" asChild>
            <Link to="/platform">{t("See BEEDIGIT Platform")} <ArrowRight className="ms-2 h-4 w-4" /></Link>
          </Button>
        </div>
      </div>
    </section>
  );
}